<form #form="ngForm" [class.loading]="isLoading" (ngSubmit)="onSubmit()" invalidControlScroll>
    <app-header title="self-serve.companyDetails.addYourCompanyInfo"></app-header>
    <div class="responsive-grid margin-bottom-3">
        <div class="row">
            <mat-form-field>
                <mat-label>{{ 'self-serve.companyDetails.companyNameLabel' | translate }}</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    name="companyName"
                    #legalCompanyName="ngModel"
                    [(ngModel)]="company.name"
                />
                <mat-error *ngIf="legalCompanyName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'self-serve.companyDetails.legalNameLabel' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    name="legalCompanyName"
                    #legalCompanyName="ngModel"
                    [(ngModel)]="company.doingBusinessAsName"
                />
                <mat-error *ngIf="legalCompanyName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field>
                <mat-label>{{ 'self-serve.companyDetails.dateFoundedLabel' | translate }}</mat-label>
                <input
                    required
                    name="incorporationDate"
                    #incorporationDate="ngModel"
                    [(ngModel)]="company.incorporationDate"
                    [matDatepicker]="incorporationDatePicker"
                    matInput
                />
                <mat-datepicker-toggle matSuffix [for]="incorporationDatePicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #incorporationDatePicker></mat-datepicker>
                <mat-error *ngIf="incorporationDate.invalid">{{ incorporationDate.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'self-serve.companyDetails.primaryPhoneLabel' | translate }}</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    name="phonePrimary"
                    [(ngModel)]="company.phonePrimary"
                    #phonePrimary="ngModel"
                    placeholder="{{ 'self-serve.companyDetails.primaryPhonePlaceholder' | translate }}"
                />
                <mat-error *ngIf="phonePrimary.invalid">{{ phonePrimary.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field>
                <mat-label>{{ 'self-serve.companyDetails.industryLabel' | translate }}</mat-label>
                <input matInput type="text" name="industry" #industry="ngModel" [(ngModel)]="company.industry" />
                <mat-error *ngIf="industry.invalid">{{ industry.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'self-serve.companyDetails.notificationEmailLabel' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    name="notification_email"
                    required
                    #email="ngModel"
                    [(ngModel)]="company.notification_email"
                    placeholder="{{ 'self-serve.companyDetails.notificationEmailPlaceholder' | translate }}"
                />
                <mat-error *ngIf="email.invalid">{{ email.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </div>

    <app-header title="self-serve.companyDetails.addYourCompanyLogo"></app-header>
    <p class="text-color-secondary-font margin-bottom-4">
        {{ 'self-serve.companyDetails.companyLogoDetails' | translate }}
    </p>

    <app-company-logo-uploader></app-company-logo-uploader>
    <ui-banner class="margin-bottom-6" variant="bulb"> {{ 'settings.company-logo.tipMessage' | translate }}</ui-banner>

    <app-header title="self-serve.companyDetails.addYourOffice"></app-header>
    <mat-form-field class="w-100">
        <mat-label>{{ 'company.office-form.nameLabel' | translate }}</mat-label>
        <input
            matInput
            type="text"
            required
            name="officeName"
            #name="ngModel"
            [(ngModel)]="office.name"
            placeholder="{{ 'company.office-form.canadianHeadquarters' | translate }}"
        />
        <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
    </mat-form-field>

    <app-address [showAutocomplete]="true" name="officeAddress" [(ngModel)]="office"></app-address>

    <div class="flex buttons justify-end">
        <ui-button *ngIf="showIWillDoItLater" type="outline" (click)="next()"
            >{{ 'self-serve.iWillDoItLater' | translate }}
        </ui-button>
        <ui-button type="primary" [submit]="true" [disabled]="isSaving">{{ 'save' | translate }}</ui-button>
    </div>
</form>
